import { useAllSizes } from "http-hooks/size/useSize";
import DeleteSize from "components/size/DeleteSize";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  itmsz: "",
  umid: "",
  ag_status: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "itmsz", header: "Item Size" },
  {
    key: "unitname",
    header: "Unit Name",
    render: (item) => item.ParentUnit?.unitname || item.umid,
  },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function SizeMaster() {
  const [selectedStatus, setSelectedStatus] = useState(statusOptions[1]);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("size", id);

  const handleItemSizeSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, itmsz: searchTerm, page: 1 }));
  };

  const handleUnitSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, umid: searchTerm, page: 1 }));
  };

  const handleStatusChange = (statusOption) => {
    setSelectedStatus(statusOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: statusOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allsizes, page: currentPage, totalPages } = [],
  } = useAllSizes(filter);

  return (
    <MasterPage
      title="Size Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add size</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleItemSizeSearch}
              label="Item Size"
              placeholder="Search Item Size"
            />
          </FilterCell>
          <FilterCell>
            <InputSearch
              onSearch={handleUnitSearch}
              label="Unit Name"
              placeholder="Search Unit Name"
            />
          </FilterCell>
          <FilterCell>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              options={statusOptions}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allsizes}
      isLoading={isLoading}
      rowKey="itmszid"
      deleteComponent={DeleteSize}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.itmszid)}
            title="Edit Size"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.itmszid)}
            title="Delete Size"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
